import { render, staticRenderFns } from "./TheTransfer.vue?vue&type=template&id=60c66946&scoped=true"
import script from "./TheTransfer.vue?vue&type=script&lang=js"
export * from "./TheTransfer.vue?vue&type=script&lang=js"
import style0 from "./TheTransfer.vue?vue&type=style&index=0&id=60c66946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c66946",
  null
  
)

export default component.exports